define(
  'loadCtaResource',[
    'loadCss',
    'touchHelper'
  ],
  (
    loadCss
  ) => {
    'use strict';

    const modalCss = document.querySelector('#modalCss');

    /**
     * @private
     * handlerClickCtaButtons: load css resources to CTA modals.
     *
     * @param {Event} event with the information associated to the touch or click event.
     */
    function handlerClickCtaButtons(event) {
      if (event.target.closest('[data-cta-button]')) {
        loadCss(modalCss.value);
      }
    }

    function closeModal(event) {
      if (event.target.classList.contains('modal__close')) {
        const overlayGlobal = document.getElementById('nhs_OverlayPanelCTAGlobal');
        document.getElementById('nhs_BasicContactForm').style.display = 'none';
        if (overlayGlobal) {
          overlayGlobal.removeClass('is-visible');
        }

        document.body.removeClass('nhs_NoScrollComplete');
      }
    }

    document.onClickOrTap(handlerClickCtaButtons);
    document.addEventListener('click', closeModal);
  }
);

